import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNotify, useRedirect } from "react-admin";

import { API, graphqlOperation } from "aws-amplify";
import {
  getInventorieAiles,
  getInventoryItem,
} from "../../../../graphql/inventory/custom-queries";
import { aisleByActiveByZoneBySortKey } from "../../../../graphql/reloadyard/custom-queries";
import {
  createInventoryItem,
  deleteInventoryItemMini,
  updateInventorySearch,
  updateInventoryItemMini,
} from "../../../../graphql/inventory/custom-mutations";
import {
  createShipmentLineItemInventoryItem,
  deleteShipmentLineItemInventoryItem,
} from "../../../../graphql/mutations";
import { updateBarcodeLocation } from "../../../../graphql/barcodes/custom-mutations";
import { updateShipmentLineItemInventoryItem } from "../../../../graphql/outbound/custom-mutations";
import {
  sanitizeInventory,
  sanitizeInventoryItem,
} from "../../../../graphql/inventory/inventoryCRUD";

import { makeStyles } from "@material-ui/core/styles";
import {
  CardActions,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
  CircularProgress,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  Tabs,
  Tab,
  Backdrop,
  CardContent,
} from "@material-ui/core";
import { ExpandMoreIcon } from "../../../../components/common/iconography";
import { format } from "date-fns";
import CheckBoxOutlineBlankOutlinedIcon from "@material-ui/icons/CheckBoxOutlineBlankOutlined";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import {
  AreaType,
  LocationLoadType,
  MAX_PHOTO_NUM_INVENTORY,
  OutboundStatus,
  ResourceType,
  ShipmentLineItemStatus,
} from "../../../../utils/constants";
import ErrorCard from "../../../../components/ErrorCard";
import { logError } from "../../../../utils/appUtils";
import { canMergeInventoryItems } from "../../../../utils/damagedInventory";
import { NoteType, LotTypeNames } from "../../../../utils/constants";
import {
  canRelocate,
  filterAisles,
  filterAreas,
  filterZones,
  getLocationFullName,
  isBulkLocation,
  isUnmanagedLocation,
  promiseSetCapacityUsed,
  setInventoryAisleList,
} from "../../../../utils/locationUtils";
import {
  getUnloadStamp,
  validateTrackRelocate,
} from "../../../../utils/trackRelocate";
import { getUnitName } from "../../../../utils/loadTypeUtils";
import { trimDecimal } from "../../../../utils/utils";
import CrewCard from "../../../../components/common/CrewCard";
import PhotoManager from "../../../../components/common/PhotoManager";
import { CustomFieldsMobile } from "../../../../components/common/CustomFields";
import { AisleMap } from "./AisleMap";
import { useInventorySearchContext } from "../context";

function a11yProps(index) {
  return { id: `inventory-tab-${index}` };
}

const useStyles = makeStyles((theme) => ({
  actions: {
    display: "flex",
    justifyContent: "space-between",
  },
  photoErrorSection: {
    paddingLeft: theme.spacing(2),
  },
  progress: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 300,
  },
  notes: {
    border: "0px solid rgba(0, 0, 0, .25)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  backdrop: {
    zIndex: 1001,
  },
}));

export const InventoryRelocateCard = ({ history, match }) => {
  const notify = useNotify();
  const classes = useStyles();
  const redirect = useRedirect();
  const [invalidIdError, setInvalidIdError] = useState();
  const [note, setNote] = useState();
  const [tabValue, setTabValue] = React.useState(0);
  const location = useLocation();
  const scannedBarcodes = location.state?.scannedBarcodes;
  const [matchedBarcodes, setMatchedBarcodes] = useState([]);
  const scannedQuantity = matchedBarcodes?.length || 0;
  const { state, dispatch } = useInventorySearchContext();
  const {
    currentInventory,
    areas,
    zones,
    selectedArea,
    selectedInventoryItem,
    loading,
    bayList,
    selectedLocation,
    originalInventoryItem,
    disableRelocateValidation,
    inventoryItemBayList,
    selectedLocationInventories,
  } = state;

  const getInventoryItemById = async (id) => {
    const response = await API.graphql(
      graphqlOperation(getInventoryItem, { id }),
    );
    return response.data.getInventoryItem;
  };

  const isItemOnActiveOutbound = (inventory, inventoryItem) => {
    const lineItems = inventory?.shipmentLineItems?.items ?? [];
    for (const shipmentLineItem of lineItems) {
      const outboundStatus = shipmentLineItem?.outboundShipment?.status;
      if (!outboundStatus) continue;
      if (
        outboundStatus !== OutboundStatus.PENDING &&
        outboundStatus !== OutboundStatus.RELEASED
      ) {
        const hasMatchingInventoryItem = (
          shipmentLineItem.inventoryItems?.items ?? []
        ).some((lineItemInventoryItem) => {
          return lineItemInventoryItem.inventoryItemId === inventoryItem.id;
        });
        if (hasMatchingInventoryItem) return true;
      }
    }
    return false;
  };

  const getCommittedQuantityToMove = (inventoryItem, quantityToMove) => {
    return trimDecimal(
      Math.min(quantityToMove, inventoryItem?.quantityCommitted || 0),
    );
  };

  const isRelocateBlockedByActiveOutbound = (inventoryItem) => {
    if (!inventoryItem || inventoryItem.quantityCommitted <= 0) return false;
    const inventory = inventoryItem.inventory ?? currentInventory;
    return isItemOnActiveOutbound(inventory, inventoryItem);
  };

  const getShipmentLineItemInventoryItems = (inventoryItem) => {
    const shipmentLineItems =
      inventoryItem?.inventory?.shipmentLineItems?.items ?? [];

    return shipmentLineItems
      .filter((shipmentLineItem) => {
        return shipmentLineItem.status !== ShipmentLineItemStatus.SHIPPED;
      })
      .flatMap((shipmentLineItem) => {
        const lineItemInventoryItems =
          shipmentLineItem.inventoryItems?.items ?? [];
        return lineItemInventoryItems
          .filter((lineItemInventoryItem) => {
            return lineItemInventoryItem.inventoryItemId === inventoryItem.id;
          })
          .map((lineItemInventoryItem) => {
            return {
              ...lineItemInventoryItem,
              shipmentLineItemId:
                lineItemInventoryItem.shipmentLineItemId ?? shipmentLineItem.id,
              outboundShipmentId:
                lineItemInventoryItem.outboundShipmentId ??
                shipmentLineItem.outboundShipmentId,
              inventoryId:
                lineItemInventoryItem.inventoryId ??
                shipmentLineItem.inventoryId,
              reloadYardId:
                lineItemInventoryItem.reloadYardId ??
                currentInventory.reloadYardId,
              groups: lineItemInventoryItem.groups ?? inventoryItem.groups,
              status: lineItemInventoryItem.status ?? shipmentLineItem.status,
              units:
                lineItemInventoryItem.units ??
                inventoryItem.inventory?.inventoryUOM,
            };
          });
      });
  };

  const buildShipmentLineItemInventoryItemInput = (
    shipmentLineItemInventoryItem,
    overrides = {},
  ) => {
    const input = {
      ...shipmentLineItemInventoryItem,
      ...overrides,
    };

    delete input.createdAt;
    delete input.updatedAt;
    delete input.inventoryItem;

    return input;
  };

  const doCreateShipmentLineItemInventoryItem = (
    shipmentLineItemInventoryItem,
  ) => {
    const input = buildShipmentLineItemInventoryItemInput(
      shipmentLineItemInventoryItem,
    );
    delete input.id;

    return API.graphql(
      graphqlOperation(createShipmentLineItemInventoryItem, { input }),
    );
  };

  const doUpdateShipmentLineItemInventoryItem = (
    shipmentLineItemInventoryItem,
  ) => {
    const input = buildShipmentLineItemInventoryItemInput(
      shipmentLineItemInventoryItem,
    );

    return API.graphql(
      graphqlOperation(updateShipmentLineItemInventoryItem, { input }),
    );
  };

  const doDeleteShipmentLineItemInventoryItem = (
    shipmentLineItemInventoryItem,
  ) => {
    const input = { id: shipmentLineItemInventoryItem.id };
    return API.graphql(
      graphqlOperation(deleteShipmentLineItemInventoryItem, { input }),
    );
  };

  const buildShipmentLineItemInventoryItemMap = (inventoryItem) => {
    const shipmentLineItemInventoryItems =
      getShipmentLineItemInventoryItems(inventoryItem);

    return shipmentLineItemInventoryItems.reduce((accumulator, currentItem) => {
      accumulator[currentItem.shipmentLineItemId] = currentItem;
      return accumulator;
    }, {});
  };

  const rebalanceShipmentLineItemInventoryItems = ({
    fromInventoryItem,
    toInventoryItemId,
    toInventoryItem,
    quantityToMove,
  }) => {
    const moveQuantity = trimDecimal(quantityToMove || 0);
    if (!toInventoryItemId || moveQuantity <= 0) return [];
    if (fromInventoryItem.id === toInventoryItemId) return [];

    const mutationList = [];
    let remainingToMove = moveQuantity;
    const targetLineItemInventoryItemMap =
      buildShipmentLineItemInventoryItemMap(toInventoryItem);
    const sourceLineItemInventoryItems =
      getShipmentLineItemInventoryItems(fromInventoryItem);

    for (const sourceLineItemInventoryItem of sourceLineItemInventoryItems) {
      if (remainingToMove <= 0) break;

      const sourceQuantityToPick =
        sourceLineItemInventoryItem.quantityToPick || 0;
      if (sourceQuantityToPick <= 0) continue;

      const quantityForThisLineItem = trimDecimal(
        Math.min(remainingToMove, sourceQuantityToPick),
      );
      const sourceQuantityRemaining = trimDecimal(
        sourceQuantityToPick - quantityForThisLineItem,
      );
      const existingTargetLineItemInventoryItem =
        targetLineItemInventoryItemMap[
          sourceLineItemInventoryItem.shipmentLineItemId
        ];

      if (existingTargetLineItemInventoryItem) {
        mutationList.push(
          doUpdateShipmentLineItemInventoryItem({
            ...existingTargetLineItemInventoryItem,
            quantityToPick: trimDecimal(
              (existingTargetLineItemInventoryItem.quantityToPick || 0) +
                quantityForThisLineItem,
            ),
          }),
        );

        targetLineItemInventoryItemMap[
          sourceLineItemInventoryItem.shipmentLineItemId
        ] = {
          ...existingTargetLineItemInventoryItem,
          quantityToPick: trimDecimal(
            (existingTargetLineItemInventoryItem.quantityToPick || 0) +
              quantityForThisLineItem,
          ),
        };

        if (sourceQuantityRemaining > 0) {
          mutationList.push(
            doUpdateShipmentLineItemInventoryItem({
              ...sourceLineItemInventoryItem,
              quantityToPick: sourceQuantityRemaining,
            }),
          );
        } else {
          mutationList.push(
            doDeleteShipmentLineItemInventoryItem(sourceLineItemInventoryItem),
          );
        }
      } else if (sourceQuantityRemaining === 0) {
        const movedLineItemInventoryItem = {
          ...sourceLineItemInventoryItem,
          inventoryItemId: toInventoryItemId,
        };

        mutationList.push(
          doUpdateShipmentLineItemInventoryItem(movedLineItemInventoryItem),
        );
        targetLineItemInventoryItemMap[
          sourceLineItemInventoryItem.shipmentLineItemId
        ] = movedLineItemInventoryItem;
      } else {
        mutationList.push(
          doUpdateShipmentLineItemInventoryItem({
            ...sourceLineItemInventoryItem,
            quantityToPick: sourceQuantityRemaining,
          }),
        );

        const createdLineItemInventoryItem = {
          ...sourceLineItemInventoryItem,
          inventoryItemId: toInventoryItemId,
          quantityToPick: quantityForThisLineItem,
        };
        mutationList.push(
          doCreateShipmentLineItemInventoryItem(createdLineItemInventoryItem),
        );
        targetLineItemInventoryItemMap[
          sourceLineItemInventoryItem.shipmentLineItemId
        ] = createdLineItemInventoryItem;
      }

      remainingToMove = trimDecimal(remainingToMove - quantityForThisLineItem);
    }

    if (remainingToMove > 0) {
      throw new Error(
        `Unable to rebalance ${remainingToMove} committed quantity during relocate.`,
      );
    }

    return mutationList;
  };

  // A crew emptying a car by hand IS the unload, whether that happens during the
  // inbound or weeks later, so a move out of a railcar records who did it.
  // getUnloadStamp already declines to restamp an item that carries one; the row
  // actually being written is checked too, because a merge writes the row that
  // was already in the destination and the crew that unloaded that stock owns
  // its record.
  const applyUnloadStamp = (inventoryItem, unloadStamp) => {
    if (!unloadStamp) return inventoryItem;
    if (inventoryItem.unloadedBy || inventoryItem.unloadedAt)
      return inventoryItem;
    return { ...inventoryItem, ...unloadStamp };
  };

  const getRecordsUpdatedAtMap = (records) => {
    return records.reduce((updatedAtMap, record) => {
      if (!record?.id || !record?.updatedAt) {
        throw new Error("Cannot verify relocate freshness for linked records.");
      }
      updatedAtMap[record.id] = record.updatedAt;
      return updatedAtMap;
    }, {});
  };

  const getInventoryItemConcurrencyError = (
    initialInventoryItem,
    latestInventoryItem,
    label,
  ) => {
    if (!initialInventoryItem?.updatedAt || !latestInventoryItem?.updatedAt) {
      throw new Error(`Cannot verify ${label} freshness before relocate.`);
    }

    if (initialInventoryItem.updatedAt !== latestInventoryItem.updatedAt) {
      return `${label} changed since this relocate screen loaded. Please reopen and try again.`;
    }

    return null;
  };

  const getShipmentLineItemInventoryItemsConcurrencyError = (
    initialInventoryItem,
    latestInventoryItem,
  ) => {
    const initialUpdatedAtMap = getRecordsUpdatedAtMap(
      getShipmentLineItemInventoryItems(initialInventoryItem),
    );
    const latestUpdatedAtMap = getRecordsUpdatedAtMap(
      getShipmentLineItemInventoryItems(latestInventoryItem),
    );

    const initialIds = Object.keys(initialUpdatedAtMap).sort();
    const latestIds = Object.keys(latestUpdatedAtMap).sort();

    if (initialIds.length !== latestIds.length) {
      return "Committed outbound links changed since this relocate screen loaded. Please reopen and try again.";
    }

    for (const initialId of initialIds) {
      if (!latestUpdatedAtMap[initialId]) {
        return "Committed outbound links changed since this relocate screen loaded. Please reopen and try again.";
      }

      if (latestUpdatedAtMap[initialId] !== initialUpdatedAtMap[initialId]) {
        return "Committed outbound links changed since this relocate screen loaded. Please reopen and try again.";
      }
    }

    return null;
  };

  useEffect(() => {
    doGetInventoryItem(match.params.id);
    return dispatch({ type: "CLEAR_INVENTORY_ITEM" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // The zones this inventory may be put in: active, and either open to every
  // account or belonging to the account that owns the stock.
  const getPermittedZones = (area, inventoryItem) => {
    return (area?.zones?.items ?? []).filter(
      (zone) =>
        zone.active === "true" &&
        (!zone.accountId ||
          zone.accountId === inventoryItem.inventory.accountId),
    );
  };

  // The first area the crew could actually finish a move in. An area whose
  // zones are all closed to this account would open the page on a destination
  // with no zone to pick, so it is passed over rather than offered.
  const getFirstDestinationArea = (areas, inventoryItem) => {
    return (
      areas.find((area) => getPermittedZones(area, inventoryItem).length > 0) ??
      areas[0]
    );
  };

  const doGetInventoryItem = async (id) => {
    dispatch({ type: "SET_LOADING", payload: true });
    debugger;
    try {
      const inventoryItem = await getInventoryItemById(id);
      if (inventoryItem) {
        if (inventoryItem?.barcodes?.items) {
          let available = [...inventoryItem.barcodes.items];

          const scannedValues = scannedBarcodes?.map((b) => b.value) || [];
          const matchedBarcodeObjects = scannedValues
            .map((value) => {
              const idx = available.findIndex((b) => b?.value === value);
              if (idx !== -1) {
                return available.splice(idx, 1)[0];
              }
              return null;
            })
            .filter(Boolean);

          if (matchedBarcodeObjects.length > 0) {
            setMatchedBarcodes(matchedBarcodeObjects);
          }
        }

        const currentInventory = inventoryItem.inventory;
        const areas = filterAreas(
          window.appUser.reloadYard.areas.items,
          currentInventory?.reloadYardCommodity,
          AreaType.TRACK,
        );
        areas.forEach((area) => {
          area.zones.items = filterZones(
            area.zones.items,
            currentInventory.reloadYardCommodityId,
            currentInventory.accountId,
          );
        });
        if (areas.length === 0) {
          // Nothing to offer means there is no move to make. Saying so beats
          // dying half way through the render with a logged TypeError.
          const noAreaError =
            "There is no area available to relocate this inventory into.";
          notify(noAreaError, "warning");
          setInvalidIdError(noAreaError);
          return;
        }
        dispatch({ type: "SET_AREAS", payload: areas });
        const inventoryArea = areas.find(
          (itm) => itm.id === inventoryItem.areaId,
        );
        // Opening the destination selects where the stock already sits is
        // useful wherever the crew can actually move it there, and crews rely
        // on it, so that stays the seed whenever the item's own area is one of
        // the offered destinations. It is absent in two ordinary cases: stock
        // still in a railcar, because TRACK is deliberately excluded as a
        // destination, and a row whose locationId never resolved to a Location.
        // Neither is an error -- both are exactly what this page is for -- so
        // the destination then opens on the first area and zone the crew is
        // allowed to move into instead of on the source.
        const keepsSourceSelection = Boolean(
          inventoryArea && inventoryItem.location?.area,
        );
        const destinationArea = keepsSourceSelection
          ? inventoryArea
          : getFirstDestinationArea(areas, inventoryItem);
        const zones = getPermittedZones(destinationArea, inventoryItem);
        const destinationZone = keepsSourceSelection
          ? null
          : (zones[0] ?? null);

        // The aisle list has to follow the destination zone, not the source
        // one: a track's own aisles are no use to a crew unloading the car.
        const aisles = await getAisles(
          inventoryItem,
          keepsSourceSelection ? inventoryItem.zoneId : destinationZone?.id,
        );
        dispatch({ type: "SET_ZONES", payload: { zones, aisles } });
        dispatch({
          type: "SET_SELECTED_INVENTORY_ITEM",
          payload: inventoryItem,
        });
        dispatch({
          type: "SET_ORIGINAL_INVENTORY_ITEM",
          payload: { ...inventoryItem },
        });
        if (!keepsSourceSelection) {
          // SET_ORIGINAL_INVENTORY_ITEM seeds the selects from the item's own
          // location, which here is either a track the destination list
          // excludes or no location at all. Correcting the selection right
          // after it keeps that action's contract -- and the "from" display
          // that reads originalLocation -- untouched. The zone follows in its
          // own action because SET_SELECTED_AREA reads a zone off `payload.zone`
          // while every dispatcher sends `selectedZone`, so seeding it there
          // would quietly do nothing.
          dispatch({
            type: "SET_SELECTED_AREA",
            payload: { zones, selectedArea: destinationArea },
          });
          dispatch({ type: "SET_SELECTED_ZONE", payload: destinationZone });
        }
      } else {
        setInvalidIdError(`Inventory ID ${id} doesn't exist.`);
      }
    } catch (err) {
      logError(
        "inventorySearch:InventoryRelocateCard:getInventory",
        err,
        notify,
      );
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const getAisles = async (inventoryItem, zoneId) => {
    debugger;
    // No zone means nothing to list -- an area whose zones are all closed to
    // this account, or a destination the crew has yet to pick.
    if (!zoneId) return [];
    const aislesResponse = await API.graphql(
      graphqlOperation(aisleByActiveByZoneBySortKey, {
        zoneId,
        activeSortKey: { beginsWith: { active: "true" } },
        limit: 1000,
      }),
    );
    const aisles = filterAisles(
      aislesResponse.data.aisleByActiveByZoneBySortKey.items,
      inventoryItem.inventory,
    );
    return aisles;
  };

  const getZoneAisles = async (zone) => {
    try {
      const aislesResponse = await API.graphql(
        graphqlOperation(aisleByActiveByZoneBySortKey, {
          zoneId: zone.id,
          activeSortKey: { beginsWith: { active: "true" } },
          limit: 1000,
        }),
      );
      const aisles = filterAisles(
        aislesResponse.data.aisleByActiveByZoneBySortKey.items,
        selectedInventoryItem.inventory,
      );
      return aisles;
    } catch (err) {
      logError(
        "inventorySearch:InventoryRelocateCard:getZoneAisles",
        err,
        notify,
      );
    }
  };

  const handleAreaChange = (areaId) => {
    debugger;
    if (!areaId) return;
    else {
      const area = areas.find((itm) => itm.id === areaId);
      let zones = area.zones.items.filter((zone) => zone.active === "true");
      zones = zones.filter(
        (zone) =>
          !zone.accountId ||
          zone.accountId === selectedInventoryItem.inventory.accountId,
      );
      const zone = zones.length > 0 ? zones[0] : "";
      dispatch({
        type: "SET_SELECTED_AREA",
        payload: {
          zones,
          selectedArea: area,
          selectedZone: zone,
        },
      });
    }
  };

  const handleZoneChange = async (zoneId) => {
    if (!zoneId) return;
    const zone = zones.find((itm) => itm.id === zoneId);
    dispatch({ type: "SET_SELECTED_ZONE", payload: zone });
    const aisles = await getZoneAisles(zone);
    dispatch({ type: "SET_AISLES", payload: aisles });
  };

  const saveInventory = async (inventory) => {
    debugger;
    let response = await API.graphql(
      graphqlOperation(getInventorieAiles, { id: inventory.id }),
    );
    const dbInventory = response.data.getInventorie;

    setInventoryAisleList(dbInventory);
    let toUpdateInventory = { ...inventory };
    toUpdateInventory.productId = toUpdateInventory.productId || "";
    toUpdateInventory.aisleList = dbInventory.aisleList;

    toUpdateInventory = sanitizeInventory(toUpdateInventory);

    response = await API.graphql(
      graphqlOperation(updateInventorySearch, { input: toUpdateInventory }),
    );
    const updatedInventory = response.data.updateInventorie;
    dispatch({ type: "UPDATE_CURRENT_INVENTORY", payload: updatedInventory });
  };

  // The rules that refuse a move out of a railcar live in trackRelocate so this
  // screen and handleSave cannot drift apart. The destination is read from the
  // chosen location once there is one, because that is what would be written,
  // and from the Area select before then so the crew sees the reason as soon as
  // it applies rather than only on a dead Save button.
  const trackRelocateRefusal = validateTrackRelocate({
    inventoryItem: selectedInventoryItem,
    destinationArea: selectedLocation?.areaId ?? selectedArea,
  });

  const isSaveButtonDisabled = () => {
    if (!selectedLocation || !selectedInventoryItem) return true;
    if (isRelocateBlockedByActiveOutbound(selectedInventoryItem)) return true;
    if (trackRelocateRefusal) return true;
    return !canRelocate(
      bayList,
      selectedLocation,
      selectedInventoryItem,
      currentInventory,
      disableRelocateValidation,
      inventoryItemBayList,
    );
  };

  const handleSave = async () => {
    try {
      debugger;
      // If the user is trying to save without actually changing the location, there's nothing to do, so we exit early.
      // An item carrying the UNSPOTTED_VIRTUAL sentinel resolves no location at
      // all, and it is exactly the row the crew came here to repair, so a
      // missing origin can never equal the destination and must not throw.
      if (selectedLocation.id === originalInventoryItem.location?.id) return;
      dispatch({ type: "SET_LOADING", payload: true });
      const latestOriginalInventoryItem = await getInventoryItemById(
        originalInventoryItem.id,
      );
      if (!latestOriginalInventoryItem) {
        notify(
          `Inventory ID ${originalInventoryItem.id} doesn't exist.`,
          "error",
        );
        dispatch({ type: "SET_LOADING", payload: false });
        return;
      }
      // If an item with the same inventory ID already exists in the target location, we may merge the two instead of duplicating.
      // Damaged stock never merges — see canMergeInventoryItems. A refusal
      // falls through to the move/create path and stays its own row in the
      // location.
      let similarInventoryItem = selectedLocationInventories.find(
        (itm) =>
          itm.inventory.id === latestOriginalInventoryItem.inventory.id &&
          canMergeInventoryItems(itm, latestOriginalInventoryItem),
      );
      let latestSimilarInventoryItem =
        similarInventoryItem && isUnmanagedLocation(selectedLocation)
          ? await getInventoryItemById(similarInventoryItem.id)
          : null;
      if (
        similarInventoryItem &&
        isUnmanagedLocation(selectedLocation) &&
        !latestSimilarInventoryItem
      ) {
        throw new Error(
          `Unable to load target inventory item ${similarInventoryItem.id} for relocate.`,
        );
      }
      // Re-check against the freshly loaded record: the target may have been
      // flagged damaged since the location list was fetched.
      if (
        latestSimilarInventoryItem &&
        !canMergeInventoryItems(
          latestSimilarInventoryItem,
          latestOriginalInventoryItem,
        )
      ) {
        similarInventoryItem = null;
        latestSimilarInventoryItem = null;
      }
      const inventoryItemConcurrencyError = getInventoryItemConcurrencyError(
        originalInventoryItem,
        latestOriginalInventoryItem,
        "Inventory item",
      );
      if (inventoryItemConcurrencyError) {
        notify(inventoryItemConcurrencyError, "warning");
        return;
      }
      if (similarInventoryItem && latestSimilarInventoryItem) {
        const targetInventoryItemConcurrencyError =
          getInventoryItemConcurrencyError(
            similarInventoryItem,
            latestSimilarInventoryItem,
            "Target inventory item",
          );
        if (targetInventoryItemConcurrencyError) {
          notify(targetInventoryItemConcurrencyError, "warning");
          return;
        }
      }
      const shipmentLineItemInventoryItemsConcurrencyError =
        getShipmentLineItemInventoryItemsConcurrencyError(
          originalInventoryItem,
          latestOriginalInventoryItem,
        );
      if (shipmentLineItemInventoryItemsConcurrencyError) {
        notify(shipmentLineItemInventoryItemsConcurrencyError, "warning");
        return;
      }
      if (isRelocateBlockedByActiveOutbound(latestOriginalInventoryItem)) {
        notify(
          "Cannot relocate inventory assigned to an active outbound.",
          "warning",
        );
        dispatch({ type: "SET_LOADING", payload: false });
        return;
      }
      // Asked again against the record just read: this page may have been open
      // since before a manager released the car and closed its inventory out.
      const latestTrackRelocateRefusal = validateTrackRelocate({
        inventoryItem: latestOriginalInventoryItem,
        destinationArea: selectedLocation.areaId,
      });
      if (latestTrackRelocateRefusal) {
        notify(latestTrackRelocateRefusal, "warning");
        dispatch({ type: "SET_LOADING", payload: false });
        return;
      }
      // Guarantee the inventory object has a history array to track actions like movement.
      if (!currentInventory.history) currentInventory.history = [];
      const promiseList = [];
      const quantity =
        scannedQuantity > 0
          ? scannedQuantity
          : selectedInventoryItem.quantityOnHand;
      // where we would intialize the scanned quantity
      // If the user has scanned barcodes, we use the first one as the quantity.
      const moveHistoryText =
        `${quantity} ${getUnitName(currentInventory.inventoryUOM)} ` +
        `moved from ${getLocationFullName(originalInventoryItem.location)} ` +
        `to ${getLocationFullName(selectedLocation)}`;
      const newHistory = {
        type: NoteType.SHIPMENT,
        date: new Date(),
        by: window.appUser?.fullName,
        text: moveHistoryText,
      };
      const originalCommittedQuantity =
        latestOriginalInventoryItem.quantityCommitted || 0;
      let toUpdateInventoryItem = {
        ...selectedInventoryItem,
        quantityCommitted: originalCommittedQuantity,
      };
      if (!toUpdateInventoryItem.history) toUpdateInventoryItem.history = [];
      toUpdateInventoryItem.history.push(newHistory);
      const unloadStamp = getUnloadStamp(latestOriginalInventoryItem);
      // Scenario 1: Moving Entire Quantity Full relocation

      let targetInventoryItemId = latestOriginalInventoryItem.id;
      const isFullMove =
        quantity === latestOriginalInventoryItem.quantityOnHand;
      let committedQuantityToMove = originalCommittedQuantity;
      let deferDeleteInventoryItem = null;

      if (isFullMove) {
        if (similarInventoryItem && isUnmanagedLocation(selectedLocation)) {
          // there is a similar inventory item in the new location, merge the two inventory items
          // and delete the from inventory item
          toUpdateInventoryItem = { ...latestSimilarInventoryItem };
          if (!toUpdateInventoryItem.history)
            toUpdateInventoryItem.history = [];
          toUpdateInventoryItem.history.push(newHistory);
          toUpdateInventoryItem.quantityOnHand += quantity;
          toUpdateInventoryItem.quantityCommitted = trimDecimal(
            (toUpdateInventoryItem.quantityCommitted || 0) +
              originalCommittedQuantity,
          );
          toUpdateInventoryItem = applyUnloadStamp(
            toUpdateInventoryItem,
            unloadStamp,
          );
          promiseList.push(
            setLocationCapacity(true, latestOriginalInventoryItem),
          );
          promiseList.push(setLocationCapacity(false, toUpdateInventoryItem));
          promiseList.push(doUpdateInventoryItem(toUpdateInventoryItem));
          deferDeleteInventoryItem = latestOriginalInventoryItem;

          targetInventoryItemId = similarInventoryItem.id;
        } else {
          //  change the inventory item location to the new location
          toUpdateInventoryItem.areaId = selectedLocation.areaId;
          toUpdateInventoryItem.zoneId = selectedLocation.zoneId;
          toUpdateInventoryItem.aisleId = selectedLocation.aisleId;
          toUpdateInventoryItem.locationId = selectedLocation.id;
          toUpdateInventoryItem.location = selectedLocation;
          toUpdateInventoryItem.locationFullName =
            getLocationFullName(selectedLocation);
          toUpdateInventoryItem = applyUnloadStamp(
            toUpdateInventoryItem,
            unloadStamp,
          );
          promiseList.push(
            setLocationCapacity(true, latestOriginalInventoryItem),
          );
          promiseList.push(setLocationCapacity(false, toUpdateInventoryItem));
          promiseList.push(doUpdateInventoryItem(toUpdateInventoryItem));
        }
      } else {
        //Scenario 2: Partial Quantity Move
        committedQuantityToMove = getCommittedQuantityToMove(
          latestOriginalInventoryItem,
          quantity,
        );
        const remaingQuantity = trimDecimal(
          latestOriginalInventoryItem.quantityOnHand - quantity,
        );
        const toUpdateOriginalInventoryItem = {
          ...latestOriginalInventoryItem,
        };
        if (!toUpdateOriginalInventoryItem.history)
          toUpdateOriginalInventoryItem.history = [];
        toUpdateOriginalInventoryItem.quantityOnHand = remaingQuantity;
        toUpdateOriginalInventoryItem.quantityCommitted = trimDecimal(
          originalCommittedQuantity - committedQuantityToMove,
        );
        toUpdateOriginalInventoryItem.history.push(newHistory);
        promiseList.push(doUpdateInventoryItem(toUpdateOriginalInventoryItem));
        promiseList.push(
          setLocationCapacity(true, toUpdateOriginalInventoryItem),
        );
        if (similarInventoryItem && isUnmanagedLocation(selectedLocation)) {
          // there is a similar inventory item in the new location, merge the two
          toUpdateInventoryItem = { ...latestSimilarInventoryItem };
          if (!toUpdateInventoryItem.history)
            toUpdateInventoryItem.history = [];
          toUpdateInventoryItem.quantityOnHand += quantity;
          toUpdateInventoryItem.quantityCommitted = trimDecimal(
            (toUpdateInventoryItem.quantityCommitted || 0) +
              committedQuantityToMove,
          );
          toUpdateInventoryItem.history.push(newHistory);
          toUpdateInventoryItem = applyUnloadStamp(
            toUpdateInventoryItem,
            unloadStamp,
          );
          promiseList.push(doUpdateInventoryItem(toUpdateInventoryItem));
          promiseList.push(setLocationCapacity(false, toUpdateInventoryItem));

          targetInventoryItemId = similarInventoryItem.id;
        } else {
          const toCreateInventoryItem = {
            ...selectedInventoryItem,
            quantityOnHand: quantity,
            quantityCommitted: committedQuantityToMove,
            areaId: selectedLocation.areaId,
            zoneId: selectedLocation.zoneId,
            aisleId: selectedLocation.aisleId,
            locationId: selectedLocation.id,
            location: selectedLocation,
            locationFullName: getLocationFullName(selectedLocation),
            history: [...(selectedInventoryItem.history ?? []), newHistory],
            // Only the quantity that lands in the yard has been unloaded; the
            // heel left behind is still in the car and keeps no stamp. Null
            // when the source was stamped by an earlier unload, and spreading
            // null adds nothing.
            ...unloadStamp,
          };
          const createRes = await doCreateInventoryItem(toCreateInventoryItem);
          const newId = createRes?.data?.createInventoryItem?.id;
          if (!newId) {
            throw new Error("Failed to create relocated inventory item.");
          }
          targetInventoryItemId = newId;
          promiseList.push(setLocationCapacity(false, toCreateInventoryItem));
        }
      }

      promiseList.push(
        ...rebalanceShipmentLineItemInventoryItems({
          fromInventoryItem: latestOriginalInventoryItem,
          toInventoryItemId: targetInventoryItemId,
          toInventoryItem: latestSimilarInventoryItem,
          quantityToMove: committedQuantityToMove,
        }),
      );

      const needReassignInventoryItemId =
        !isFullMove ||
        (isFullMove && targetInventoryItemId !== originalInventoryItem.id);

      for (const barcode of matchedBarcodes ?? []) {
        const updatedBarcode = {
          ...barcode,
          locationId: selectedLocation.id,
          ...(needReassignInventoryItemId
            ? { inventoryItemId: targetInventoryItemId }
            : {}),
        };
        delete updatedBarcode.inventoryItem;
        delete updatedBarcode.createdAt;
        delete updatedBarcode.updatedAt;
        promiseList.push(
          API.graphql(
            graphqlOperation(updateBarcodeLocation, { input: updatedBarcode }),
          ),
        );
      }

      const results = await Promise.allSettled(promiseList);
      const resError = results.find((itm) => itm.status === "rejected");
      if (resError) {
        logError(
          "InventorySearch:InventoryRelocateCard:handleSave",
          resError,
          notify,
        );
      }

      if (deferDeleteInventoryItem) {
        await doDeleteInventoryItem(deferDeleteInventoryItem);
      }

      if (note) {
        const newNote = {
          date: new Date(),
          by: window.appUser?.fullName,
          type: NoteType.GENERIC,
          text: note,
        };
        if (currentInventory.notes) currentInventory.notes.push(newNote);
        else currentInventory.notes = [newNote];
      }
      await saveInventory(currentInventory);
      dispatch({ type: "CLEAR_SEARCH", payload: "" });
      dispatch({ type: "CLEAR_INVENTORY_ITEM" });
      history.replace("/search");
    } catch (err) {
      logError(
        "inventorySearch:InventoryRelocateCard:handleSave:saveInventory",
        err,
        notify,
        redirect,
      );
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  // const handleSave = async (saveBelowFlag=false) => {
  //  try {
  //         debugger;
  //         if (selectedLocation.id === originalInventoryItem.location.id) return;
  //         debugger;
  //         setLoading(true);
  //         let historyText;
  //         if (!currentInventory.history) currentInventory.history = [];
  //         const similarInventoryItem = selectedLocationInventories.find(itm => itm.inventory.id === originalInventoryItem.inventory.id);
  //         const promiseList = [];
  //         let toUpdateInventoryItem;

  //         if (saveBelowFlag) {
  //             toUpdateInventoryItem = {...selectedInventoryItem};
  //             toUpdateInventoryItem.areaId = selectedLocation.areaId;
  //             toUpdateInventoryItem.zoneId = selectedLocation.zoneId;
  //             toUpdateInventoryItem.aisleId = selectedLocation.aisleId;
  //             toUpdateInventoryItem.locationId = selectedLocation.id;
  //             toUpdateInventoryItem.location = {...selectedLocation, capacityUsed: 0};
  //             toUpdateInventoryItem.locationFullName = getLocationFullName(selectedLocation);
  //             promiseList.push(setLocationCapacity(false, toUpdateInventoryItem));
  //             if (!(selectedInventoryItem.location.bay === selectedLocation.bay
  //                 && selectedInventoryItem.location.position === selectedLocation.position)) {
  //                     promiseList.push(setLocationCapacity(true, originalInventoryItem));
  //             }
  //             promiseList.push(doUpdateInventoryItem(toUpdateInventoryItem));
  //         } else {
  //             if (selectedInventoryItem.quantityOnHand === originalInventoryItem.quantityOnHand) {
  //                 if (similarInventoryItem) {
  //                     toUpdateInventoryItem = {...similarInventoryItem};
  //                     toUpdateInventoryItem.quantityOnHand += selectedInventoryItem.quantityOnHand;
  //                     promiseList.push(doDeleteInventoryItem(originalInventoryItem));
  //                     promiseList.push(setLocationCapacity(true, originalInventoryItem));
  //                     promiseList.push(setLocationCapacity(false, toUpdateInventoryItem, similarInventoryItem));
  //                 } else {
  //                     toUpdateInventoryItem = {...selectedInventoryItem};
  //                     toUpdateInventoryItem.areaId = selectedLocation.areaId;
  //                     toUpdateInventoryItem.zoneId = selectedLocation.zoneId;
  //                     toUpdateInventoryItem.aisleId = selectedLocation.aisleId;
  //                     toUpdateInventoryItem.locationId = selectedLocation.id;
  //                     toUpdateInventoryItem.location = selectedLocation;
  //                     toUpdateInventoryItem.locationFullName = getLocationFullName(selectedLocation);
  //                     promiseList.push(setLocationCapacity(false, toUpdateInventoryItem));
  //                     promiseList.push(setLocationCapacity(true, originalInventoryItem));
  //                 }
  //                 promiseList.push(doUpdateInventoryItem(toUpdateInventoryItem));
  //             } else {
  //                 const remaingQuantity = originalInventoryItem.quantityOnHand - selectedInventoryItem.quantityOnHand;
  //                 const toUpdateOriginalInventoryItem = {...originalInventoryItem};
  //                 toUpdateOriginalInventoryItem.quantityOnHand = remaingQuantity;
  //                 promiseList.push(doUpdateInventoryItem(toUpdateOriginalInventoryItem));
  //                 promiseList.push(setLocationCapacity(true, toUpdateOriginalInventoryItem, originalInventoryItem));
  //                 let toUpdateInventoryItem;
  //                 if (similarInventoryItem) {
  //                     toUpdateInventoryItem = {...similarInventoryItem};
  //                     toUpdateInventoryItem.quantityOnHand += selectedInventoryItem.quantityOnHand;
  //                     promiseList.push(doUpdateInventoryItem(similarInventoryItem));
  //                     promiseList.push(setLocationCapacity(false, toUpdateInventoryItem, similarInventoryItem));
  //                 } else {
  //                     toUpdateInventoryItem = {...selectedInventoryItem};
  //                     toUpdateInventoryItem.areaId = selectedLocation.areaId;
  //                     toUpdateInventoryItem.zoneId = selectedLocation.zoneId;
  //                     toUpdateInventoryItem.aisleId = selectedLocation.aisleId;
  //                     toUpdateInventoryItem.locationId = selectedLocation.id;
  //                     toUpdateInventoryItem.location = selectedLocation;
  //                     toUpdateInventoryItem.locationFullName = getLocationFullName(selectedLocation);
  //                     promiseList.push(doCreateInventoryItem(toUpdateInventoryItem));
  //                     promiseList.push(setLocationCapacity(false, toUpdateInventoryItem));
  //                 }
  //             }
  //         }

  //         const results = await Promise.allSettled(promiseList)
  //         const resError = results.find(itm => itm.status === "rejected");
  //         if (resError) {
  //             logError("InventorySearch:InventoryRelocateCard:handleSave", resError, notify);
  //         }

  //         const quantity = selectedInventoryItem.quantityOnHand
  //         historyText = `${quantity} ${getUnitName(currentInventory.inventoryUOM)} `
  //             + `moved from ${getLocationFullName(originalInventoryItem.location)} `
  //             + `to ${getLocationFullName(selectedLocation)}`;
  //         const newHistory = {
  //             type: NoteType.SHIPMENT,
  //             date: new Date(),
  //             by: window.appUser?.fullName,
  //             text: historyText
  //         };
  //         currentInventory.history.push(newHistory);
  //    if (note) {
  //      const newNote = {
  //        date: new Date(),
  //        by: window.appUser?.fullName,
  //        type: NoteType.GENERIC,
  //        text: note,
  //      };
  //      if (currentInventory.notes)
  //        currentInventory.notes.push(newNote);
  //      else currentInventory.notes = [newNote];
  //    }
  //         await saveInventory(currentInventory);
  //         // history.replace("/search");
  //  } catch (err) {
  //    logError("inventorySearch:InventoryRelocateCard:handleSave", err, notify, redirect);
  //  } finally {
  //         setLoading(false);
  //     }
  // };

  const doCreateInventoryItem = async (inventoryItem) => {
    const toCreateInventoryItem = sanitizeInventoryItem(inventoryItem);
    delete toCreateInventoryItem.id;

    return API.graphql(
      graphqlOperation(createInventoryItem, { input: toCreateInventoryItem }),
    );
  };

  const doUpdateInventoryItem = async (inventoryItem) => {
    const toUpdateInventoryItem = sanitizeInventoryItem(inventoryItem);
    delete toUpdateInventoryItem.locationLoad;

    return API.graphql(
      graphqlOperation(updateInventoryItemMini, {
        input: toUpdateInventoryItem,
      }),
    );
  };

  const doDeleteInventoryItem = async (inventoryItem) => {
    const input = { id: inventoryItem.id };
    return API.graphql(graphqlOperation(deleteInventoryItemMini, { input }));
  };

  const handleCancel = () => {
    dispatch({ type: "CLEAR_INVENTORY_ITEM" });
    history.goBack();
  };

  const setLocationCapacity = async (removeFlag = false, inventoryItem) => {
    if (
      isUnmanagedLocation(inventoryItem.location) ||
      disableRelocateValidation
    )
      return Promise.resolve();
    const inventoryLoadType =
      currentInventory.reloadYardCommodity.commodity.locationLoadType;
    const locationLoadType =
      inventoryItem.location.locationLoad[inventoryLoadType];
    if (locationLoadType.selected) {
      let totalCapacity;
      // Adding or removing from structured location, always one load unit
      if (removeFlag) {
        totalCapacity =
          inventoryItem.location.capacityUsed - locationLoadType.capacity;
      } else {
        totalCapacity =
          inventoryItem.location.capacityUsed + locationLoadType.capacity;
      }
      if (totalCapacity === 0) {
        inventoryItem.location.productId = null;
        inventoryItem.location.productName = null;
      } else {
        inventoryItem.location.productId = currentInventory.productId;
        inventoryItem.location.productName = currentInventory.productName;
      }
      // A damaged arrival contaminates the tank -- canRelocate only lets it
      // into an empty or already contaminated one. Relocating stock back out
      // never clears the flag: the residue stays behind, so the tank is clean
      // again only when a manager clears it. See canStoreInBulkTank.
      if (
        isBulkLocation(inventoryItem.location) &&
        !removeFlag &&
        inventoryItem.isDamaged
      ) {
        inventoryItem.location.isContaminated = true;
      }
      return promiseSetCapacityUsed(inventoryItem.location, totalCapacity);
    }
  };

  const getNoteText = (note) => {
    if (!note) return "";
    return `${format(new Date(note.date), "MM/dd/yyyy hh:mm a")} by ${
      note.by
    }: ${note.text}`;
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getRelocateText = () => {
    if (
      selectedLocation &&
      selectedLocation.type === LocationLoadType.STRUCTURED
    ) {
      if (selectedLocation.id !== selectedInventoryItem.location?.id) {
        return (
          <Grid item xs={12}>
            <Typography>
              Relocate from {selectedInventoryItem.locationFullName} to{" "}
              {getLocationFullName(selectedLocation)}
            </Typography>
          </Grid>
        );
      }
      return (
        <Grid item xs={12}>
          <Typography>
            Relocate from {selectedInventoryItem.locationFullName} to ...
          </Typography>
        </Grid>
      );
    }
    return null;
  };

  if (invalidIdError) return <ErrorCard error={invalidIdError} />;

  return (
    <CrewCard
      title={currentInventory.productName}
      icon={<CheckBoxOutlineBlankOutlinedIcon fontSize="large" />}
      subheader={currentInventory.accountName}
      action={
        <IconButton edge="start" onClick={handleCancel}>
          <HighlightOffIcon fontSize="large" />
        </IconButton>
      }
      showDivider={false}
    >
      <CardContent>
        <Backdrop open={loading} className={classes.backdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container spacing={2}>
          <Grid item sm={12} xs={12}>
            <PhotoManager
              parentId={currentInventory.id}
              parentType={ResourceType.INVENTORY}
              parentLabel={
                currentInventory?.lotNumber || currentInventory?.poNumber
              }
              disabled={false}
              viewOnly={false}
              maxPhotosNum={MAX_PHOTO_NUM_INVENTORY}
              // updateParentFn={setPhotos}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Typography>Lot number: {currentInventory.lotNumber}</Typography>
          </Grid>
          <Grid item sm={6} xs={12}>
            <Typography>
              Lot type: {LotTypeNames[currentInventory.lotType]}
            </Typography>
          </Grid>

          <Grid item sm={6} xs={12}>
            <Typography>
              Quantity onhand: {currentInventory.quantityOnHand}
            </Typography>
          </Grid>
          <Grid item sm={6} xs={12}>
            <Typography>
              Date received:{" "}
              {currentInventory.receivedAt &&
                currentInventory.receivedAt &&
                `${format(
                  new Date(currentInventory.receivedAt),
                  "MM/dd/yyyy",
                )}`}
            </Typography>
          </Grid>
          {currentInventory.productCode && (
            <Grid item xs={12}>
              <Typography>
                Product code: {currentInventory.productCode}
              </Typography>
            </Grid>
          )}
          {currentInventory.customFields && (
            <Grid item xs={12}>
              <CustomFieldsMobile
                recordFields={currentInventory.customFields}
                accountFields={currentInventory.account.inventoryCustomFields}
                width={6}
              />
            </Grid>
          )}
          {trackRelocateRefusal && (
            <Grid item xs={12}>
              <Typography color="error">{trackRelocateRefusal}</Typography>
            </Grid>
          )}
          {selectedArea && (
            <>
              <Grid item sm={12}>
                <AisleMap
                  handleSave={handleSave}
                  handleAreaChange={handleAreaChange}
                  handleZoneChange={handleZoneChange}
                  isSaveButtonDisabled={isSaveButtonDisabled}
                  scannedQuantity={matchedBarcodes.length}
                />
              </Grid>
              {getRelocateText()}
            </>
          )}
          <Grid item sm={12} xs={12}>
            <TextField
              name="notes"
              id="notes"
              label="Notes"
              multiline
              minRows={3}
              required={false}
              margin="dense"
              variant="outlined"
              fullWidth
              onChange={(evt) => setNote(evt.target.value)}
              helperText={false}
              SelectProps={{
                native: true,
              }}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Accordion className={classes.notes}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                id="notes-header"
              >
                <Typography>Notes and History</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid item sm={12} xs={12}>
                  <Tabs value={tabValue} onChange={handleTabChange}>
                    <Tab label="Notes" {...a11yProps(0)} />
                    <Tab label="History" {...a11yProps(1)} />
                  </Tabs>

                  <TabPanel value={tabValue} index={0}>
                    {currentInventory.notes?.length > 0 && (
                      <Grid item sm={12} xs={12}>
                        <List dense disablePadding>
                          {currentInventory.notes &&
                            currentInventory.notes
                              .map((note, idx) => (
                                <ListItem disableGutters key={idx}>
                                  <ListItemText>
                                    {getNoteText(note)}
                                  </ListItemText>
                                </ListItem>
                              ))
                              .reverse()}
                        </List>
                      </Grid>
                    )}
                  </TabPanel>
                  <TabPanel value={tabValue} index={1}>
                    {selectedInventoryItem?.history?.length > 0 && (
                      <Grid item sm={12} xs={12}>
                        <List dense disablePadding>
                          {selectedInventoryItem.history
                            .map((note, idx) => (
                              <ListItem disableGutters key={idx}>
                                <ListItemText>{getNoteText(note)}</ListItemText>
                              </ListItem>
                            ))
                            .reverse()}
                        </List>
                      </Grid>
                    )}
                  </TabPanel>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button
          onClick={handleSave}
          color="primary"
          size="large"
          disabled={isSaveButtonDisabled()}
        >
          Save
        </Button>
        <Button onClick={handleCancel} size="large">
          Cancel
        </Button>
      </CardActions>
    </CrewCard>
  );
};

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
};
